import ru from './ru.json';
import en from './en.json';
import es from './es.json';

export default { ru, en, es };